import moment from 'moment';

/**
 * THIN-8018 (IS-24398): the calendar day (YYYY-MM-DD) of a dashboard date value, exactly as the
 * dashboard's own requests compute it (`moment(selectedDate).format('YYYY-MM-DD')`), so the Daily
 * Session Notes page opens on the day the therapist is looking at.
 *
 * Never shift the value by the browser's UTC offset first. That idiom turns a bare `YYYY-MM-DD`
 * string (parsed as UTC midnight) back into the local day, but the dashboard holds a `Date` that
 * carries the current time of day; adding the offset to that pushes the clock forward 5h (CDT) /
 * 4h (EDT), so from 7pm Central / 8pm Eastern the day became tomorrow and evening notes were
 * created, and billed, a day ahead.
 */
export const toCalendarDay = (value: Date | string | number): string =>
  moment(value).format('YYYY-MM-DD');
